import Form_12 from './Form_12-redux';

export default Form_12;
